import { IonIcon } from '@ionic/react';
import { checkmarkCircle, chevronForwardOutline } from 'ionicons/icons';
import { MouseEventHandler, useEffect, useState } from 'react';
import { WP_Filter_Children } from '../../model/tags/tags';
import { SanitizeHTML } from '../globals/SanitizeHTML';

interface FilterMenuItemProps {
  id: number;
  title: string;
  color: string;
  tagsNames?: WP_Filter_Children[] | undefined;
  icon: string;
  onClick?: MouseEventHandler<HTMLElement> | undefined;
}

export const FilterMenuItem: React.FC<FilterMenuItemProps> = ({
  id,
  title,
  color,
  tagsNames,
  icon,
  onClick,
}) => {
  const [listOfTagsNameSelected, setListOfTagsNameSelected] = useState<
    string | undefined
  >('');

  useEffect(() => {
    let tagsSelectedString = tagsNames
      ?.map((tag) => {
        return tag.name;
      })
      .join(' - ');
    if (tagsSelectedString && tagsSelectedString.length > 60) {
      tagsSelectedString = tagsSelectedString.substring(0, 60) + '...';
    }
    setListOfTagsNameSelected(tagsSelectedString);
  }, [tagsNames]);

  return (
    <li
      data-id={id}
      className="flex w-full justify-between items-center py-5 border-b border-gray-200 cursor-pointer"
      onClick={onClick}
    >
      <div className="flex flex-row justify-start items-center">
        <div
          className="flex justify-center items-center rounded-full min-w-[2.5rem] h-10 w-10 mr-3"
          style={{
            backgroundColor: color,
          }}
        >
          <i className={`text-white ` + icon}></i>
        </div>
        <div className="flex flex-col justify-start">
          <div className="flex flex-row justify-start items-center">
            <p className="font-medium text-black">{title}</p>
            {tagsNames !== undefined && tagsNames.length > 0 && (
              <IonIcon
                icon={checkmarkCircle}
                className="text-lg mx-1 text-black"
              />
            )}
          </div>
          {listOfTagsNameSelected !== '' && (
            <SanitizeHTML
              html={listOfTagsNameSelected}
              tag="p"
              className="text-xs text-lightGrey font-medium"
            />
          )}
        </div>
      </div>
      <IonIcon icon={chevronForwardOutline} className="text-black text-sm" />
    </li>
  );
};
